import React, { useEffect } from 'react'
import jwt_decode from 'jwt-decode'
import { useLocation, Navigate, useNavigate } from 'react-router-dom'
import { orderActivated } from '../../../../../api/orders/ordersAPI'

export default function OrderActivated() {
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search)

  const ct = queryParams.get('ct')
  const oid = queryParams.get('oid')
  const companyId = queryParams.get('company_id')

  const token = localStorage.getItem('sd_cp.jwt:tkn')

  const isAuthenticated = (() => {
    if (!token) return false
    try {
      const decoded = jwt_decode(token)
      return !!decoded?.company_id && !!decoded?.company_level
    } catch {
      return false
    }
  })()

  useEffect(() => {
    localStorage.setItem('ProductCode', 'DR')
    if (ct && oid && companyId) {
      localStorage.setItem('ct', ct)
      localStorage.setItem('oid', oid)
      localStorage.setItem('OrderActivatedCompanyId', companyId)
    }

    if (ct && oid && isAuthenticated && companyId) {
      activateOrder()
    }
  }, [ct, oid, companyId])

  const activateOrder = async () => {
    try {
      const response = await orderActivated({ ct, oid })
      const isAlreadyActivatedMsg = '<h1>Your order is already Activated.</h1>'

      const isAlreadyActivated =
        typeof response.data === 'string' &&
        response.data.includes(isAlreadyActivatedMsg)

      localStorage.setItem('isAlreadyActivated', isAlreadyActivated)
      localStorage.setItem('OrderActivated', true)
    } catch (error) {
      localStorage.setItem('OrderActivated', false)
    } finally {
      navigate('/', { replace: true })
    }
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return null
}
